import { BaseViewStore } from 'core/stores';
import { ApplicationStore } from 'platform/application/stores';
import { SellerEdit3PLCredentialsForm } from '../forms';
import { action, makeObservable, observable } from 'mobx';
import { sourceOfChange, viewStoreName, lookupRouteName } from 'common/constants';
import _ from 'lodash';
import BaasicDropdownViewStore from 'common/stores/BaasicDropdownViewStore';
import { LookupStore } from 'modules/lookup/stores';
import { DaVinciBusinessPartners } from '../pages';

class SellerEdit3PLCredentialsViewStore extends BaseViewStore {
	seller;
	warehouses = [];
	@observable warehouseManagementType = null;

	form = new SellerEdit3PLCredentialsForm({
		onSuccess: async () => {
			await this.updateSeller3PLCredentials();
		},
	});

	constructor(rootStore, { modalParams }) {
		super(rootStore);
		makeObservable(this);
		this.modalParams = modalParams;
		this.sellerId = modalParams.data.selectedItem ? modalParams.data.selectedItem.id : null;
		this.applicationStore = new ApplicationStore(rootStore);
		this.warehouseManagementTypeDropdownStore = new BaasicDropdownViewStore({
			store: new LookupStore(this.rootStore),
			value: this.warehouseManagementType,
			lookupRoute: lookupRouteName.warehouseManagementType,
			onChangeCallback: value => {
				this.warehouseManagementType = value;
			},
		});
		this.initialize();
	}

	@action.bound
	initialize = async () => {
		this.suspend();
		if (
			this.modalParams.data.parentView.store_path === viewStoreName.sellerListViewStore ||
			this.modalParams.data.parentView.isUpdateAction
		) {
			await Promise.all([this.initializeSellerData(), this.initializeWarehouseData()]);
		} else {
			this.warehouses = this.modalParams.data.parentView.warehouses;
		}
		await this.prepareData();
		this.resume();
	};

	initializeSellerData = async () => {
		await this.applicationStore.getApplication(this.sellerId, {
			embed: ['sellerOrganizationInfo', 'warehouseManagements'],
		});
		this.seller = this.applicationStore.item;
	};

	initializeWarehouseData = async () => {
		this.warehouses = (await this.applicationStore.find({
			embed: ['warehouseOrganizationInfo'],
			search: null,
			rpp: 30,
			page: 1,
			warehouseOnly: true,
			isOrganizationActive: true,
		})).item;
	};

	@action.bound
	prepareData = async () => {
		if (
			this.modalParams.data.parentView.store_path === viewStoreName.sellerListViewStore ||
			this.modalParams.data.parentView.isUpdateAction
		) {
			this.prepareEditCredentialsList();
		} else {
			this.prepareCreateCredentialsList();
		}
	};

	prepareEditCredentialsList = () => {
		_.each(this.warehouses, warehouse => {
			let warehouseOrganizationInfo = warehouse.warehouseOrganizationInfo;
			const warehouseManagement = _.find(this.seller.warehouseManagements, warehouseManagement => {
				return warehouseManagement.warehouseOrganizationInfoId === warehouseOrganizationInfo.id;
			});

			this.form.$('sellerCredentials').add([
				{
					warehouseName: warehouse.identifier,
					warehouseManagementTypeId: warehouseOrganizationInfo.warehouseManagementTypeId,
					customerId: warehouseManagement ? warehouseManagement.customerId : null,
					clientId: warehouseManagement ? warehouseManagement.clientId : null,
					clientSecret: warehouseManagement ? warehouseManagement.clientSecret : null,
					vendorId: warehouseManagement ? warehouseManagement.vendorId : null,
					username: warehouseManagement ? warehouseManagement.username : null,
					password: warehouseManagement ? warehouseManagement.password : null,
					warehouseOrganizationInfoId: warehouseOrganizationInfo.id,
					sellerId: this.seller.id,
				},
			]);
		});
	};

	prepareCreateCredentialsList = () => {
		_.each(this.modalParams.data.parentView.warehouseManagements, warehouseManagement => {
			this.form.$('sellerCredentials').add([
				{
					warehouseName: warehouseManagement.warehouseName,
					warehouseManagementTypeId: warehouseManagement.warehouseOrganizationInfo.warehouseManagementTypeId,
					customerId: warehouseManagement.customerId,
					clientId: warehouseManagement.clientId,
					clientSecret: warehouseManagement.clientSecret,
					vendorId: warehouseManagement.vendorId,
					username: warehouseManagement.username,
					password: warehouseManagement.password,
					warehouseOrganizationInfoId: warehouseManagement.warehouseOrganizationInfoId,
					warehouseOrganizationInfo: warehouseManagement.warehouseOrganizationInfo,
				},
			]);
		});
	};

	@action.bound
	updateSeller3PLCredentials = async () => {
		this.suspend();
		try {
			const { sellerCredentials } = this.form.values();
			if (
				this.modalParams.data.parentView.store_path === viewStoreName.sellerListViewStore ||
				this.modalParams.data.parentView.isUpdateAction
			) {
				await this.applicationStore.updateSellerWarehouseManagements(
					{
						sellerId: this.seller.id,
						customerId: sellerCredentials.customerId,
						clientId: sellerCredentials.clientId,
						clientSecret: sellerCredentials.clientSecret,
						vendorId: sellerCredentials.vendorId,
						username: sellerCredentials.username,
						password: sellerCredentials.password,
						warehouseManagements: sellerCredentials,
					},
					this.modalParams.data.parentView.store_path === viewStoreName.sellerListViewStore
						? sourceOfChange.sellerEditUpdateWarehouseManagements
						: sourceOfChange.sellerListUpdateWarehouseManagements
				);
				this.rootStore.notificationStore.success([
					'SELLER3PLCREDENTIALS.SUCCESS',
					{ sellerName: this.seller.applicationTitle },
				]);
			} else {
				this.modalParams.data.parentView.warehouseManagements = sellerCredentials;
				this.rootStore.notificationStore.success(['SELLER3PLCREDENTIALS.UPDATED']);
			}
			this.modalParams.success();
		} catch (error) {
			this.rootStore.notificationStore.error([
				'SELLER3PLCREDENTIALS.ERROR',
				{ sellerName: this.seller.applicationTitle },
			]);
		}
		this.resume();
	};

	openDaVinciBusinessPartnersModal = selectedField => {
		this.openNestedModal({
			data: { ...this, selectedField },
			component: DaVinciBusinessPartners,
			className: 'ReactModal--lrg',
			name: 'daVinciBusinessPartnersModal',
		});
	};
}

export default SellerEdit3PLCredentialsViewStore;



// WEBPACK FOOTER //
// ./src/modules/seller/stores/SellerEdit3PLCredentialsViewStore.js